export var SLIDES_PER_VIEW_DEFAULT_VALUE = 1;
export var LAST_SLIDE_THRESHOLD = 0.95;
export var WAIT_TIME = 100;
export var SLIDER_CLASSNAME = 'keen-slider';
export var SLIDE_CLASSNAME = "".concat(SLIDER_CLASSNAME, "__slide");
//# sourceMappingURL=constants.js.map